// extracted by mini-css-extract-plugin
export default {"ageOnSetInput":"LifeStageAgeMode_ageOnSetInput__p7w+F","ageOnSetSelectBox":"LifeStageAgeMode_ageOnSetSelectBox__jScFq"};